/* cro-loop.js: GIF-style loops (muted autoplay MP4 from a `video` setting via video_tag, class "cro-loop__video").
   - plays only while on screen (saves battery and decode time; Safari also pauses off-screen video on its own)
   - prefers-reduced-motion: stays on the poster frame (the approved still) and offers controls instead of moving
   - iOS Low Power Mode refuses autoplay: play() rejects, the poster stays, nothing breaks
   - [data-cro-loop-decor] (a background loop with the same still drawn underneath, e.g. mk-lv-hero): reduced motion
     hides the video instead of offering controls, so the still shows and no player chrome sits on the picture
   Erozin copy (assets/ero-loop.js): the poster comes as `data-poster` and is set ~1200 px before the clip reaches the screen. A plain
   `poster` is fetched at parse time; four of them competed with the hero image on slow 4G (23-10). */
const SEL = 'video.cro-loop__video';
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

function hold(v) {
  v.pause();
  v.removeAttribute('autoplay');
  if (v.hasAttribute('data-cro-loop-decor')) { v.hidden = true; return; }
  v.controls = true;
}

const near = new IntersectionObserver((entries) => {
  for (const e of entries) {
    if (!e.isIntersecting) continue;
    const v = e.target;
    if (v.dataset.poster && !v.getAttribute('poster')) v.poster = v.dataset.poster;
    near.unobserve(v);
  }
}, { rootMargin: '1200px 0px' });

function wire(v) {
  if (v.dataset.croLoop) return;
  v.dataset.croLoop = '1';
  v.muted = true;
  v.playsInline = true;
  if (v.dataset.poster) near.observe(v);
  if (reduce.matches) { hold(v); return; }
  io.observe(v);
}

const io = new IntersectionObserver((entries) => {
  for (const e of entries) {
    const v = e.target;
    if (reduce.matches) { hold(v); continue; }
    if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else { v.pause(); }
  }
}, { rootMargin: '150px 0px' });

document.querySelectorAll(SEL).forEach(wire);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll(SEL).forEach(wire));
reduce.addEventListener?.('change', () => document.querySelectorAll(SEL).forEach((v) => { if (reduce.matches) hold(v); }));
